import {Component, ChangeDetectionStrategy} from '@angular/core';
import {IconsComponent} from '../dummy-components/icons.component';
import {HistoryDashboardComponent} from '../history-dashboard/history-dashboard.component';
import {TranslateModule} from '@ngx-translate/core';
import {HeaderComponent} from '../header/header.component';
import {IconComponent} from '../icon/icon.component';

@Component({
    selector: 'app-history-overlay',
    templateUrl: './history-overlay.component.html',
    styleUrls: ['./history-overlay.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HistoryDashboardComponent,
        TranslateModule,
        HeaderComponent,
        IconComponent
    ]
})
export class HistoryOverlayComponent extends IconsComponent {
}
